var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-grid',{attrs:{"auto-resize":"","highlight-hover-row":"","data":_vm.tableData,"toolbar-config":_vm.tableToolbar,"columns":_vm.tableColumns,"loading":_vm.loading,"height":500,"size":"mini","resizable":"","border":"","round":"","row-id":"noticeOrderCode","seq-config":{ startIndex: (_vm.tablePage.curPage - 1) * _vm.tablePage.pageSize },"radio-config":{
    highlight: true,
    trigger: 'row',
    reserve: true,
    strict: true,
  }},on:{"radio-change":function (e) { return _vm.$emit('radio-change', e); }},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_vm._t("header")]},proxy:true},{key:"pager",fn:function(){return [_vm._t("pager")]},proxy:true},{key:"specInfo",fn:function(ref){
  var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.spec)+" "+_vm._s(row.specUnit))])]}},{key:"noticeByName",fn:function(ref){
  var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.noticeByName))]),_c('br'),_c('span',[_vm._v(_vm._s(row.noticeTime))])]}},{key:"noticeOrderStatus",fn:function(ref){
  var row = ref.row;
return [(row.v_noticeOrderStatus)?_c('el-tag',{attrs:{"size":"mini","type":row.noticeOrderStatus == 'N' ? '' : 'success'}},[_vm._v(" "+_vm._s(row.v_noticeOrderStatus)+" ")]):_vm._e()]}},{key:"noticeCostStatus",fn:function(ref){
  var row = ref.row;
return [(row.v_noticeCostStatus)?_c('el-tag',{attrs:{"size":"mini","type":row.noticeCostStatus == 'N'
          ? ''
          : row.noticeCostStatus == 'P'
          ? 'danger'
          : 'success'}},[_vm._v(" "+_vm._s(row.v_noticeCostStatus)+" ")]):_vm._e()]}},{key:"noticePlanStatus",fn:function(ref){
          var row = ref.row;
return [(row.v_noticePlanStatus)?_c('el-tag',{attrs:{"size":"mini","type":row.noticePlanStatus == 'N'
          ? ''
          : row.noticePlanStatus == 'P'
          ? 'danger'
          : 'success'}},[_vm._v(" "+_vm._s(row.v_noticePlanStatus)+" ")]):_vm._e()]}},{key:"orderStatus",fn:function(ref){
          var row = ref.row;
return [_c('el-tag',{attrs:{"size":"mini","type":row.orderStatus === 'D' || row.orderStatus === 'T'
          ? 'danger'
          : row.orderStatus === 'R'
          ? 'warning'
          : row.orderStatus === 'Y' ||
            row.orderStatus === 'P' ||
            row.orderStatus === 'C'
          ? 'success'
          : 'light'}},[_vm._v(" "+_vm._s(row.v_orderStatus)+" ")])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }